<template>
  <div>
    <modal-vue class="col-lg-12">
      <div slot="header">
        <h3>Visualizadores!!!!</h3>
      </div>

      <div slot="body" style="margin:0px;">
        <div class="text-content" v-for="item in readers" :key="item.id">
          <span>{{item.userName}}</span>
        </div>
      </div>

      <div slot="footer">
        <lms-button
          :disabled="false"
          @click="close()"
          class="btn-danger"
          :loading="false"
        >Fechar</lms-button>
      </div>
    </modal-vue>
  </div>
</template>


<style lang="scss" scoped>
</style>


<script>
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  props: ["readers"],
  data() {
    return {
      saving: false,
      alert: {},
      userType: this.$store.getters.user.type
    };
  },
  methods: {
    close() {
      this.$emit("close");
    }
  },
  created() {}
};
</script>
